<pmv-fieldset [header]="header" *ngIf="header; else nofieldset">
  <ng-container *ngTemplateOutlet="fileUploadTemplate"></ng-container>
</pmv-fieldset>

<ng-template #nofieldset>
  <ng-container *ngTemplateOutlet="fileUploadTemplate"></ng-container>
</ng-template>

<ng-template #fileUploadTemplate>
  <div class="file-upload-main-container">

    <pmv-loading [isLoading]="loading"></pmv-loading>
    <div class="blocking-container" *ngIf="loading"></div>
    
    <p-fileUpload chooseLabel="Adicionar arquivos" customUpload="true" (onRemove)="removeFile($event)" (onSelect)="selectFiles($event)"
      multiple="multiple" [accept]="accept" [showUploadButton]="false" [showCancelButton]="false" [maxFileSize]="maxFileSize"
      invalidFileSizeMessageSummary="{0}:" [invalidFileSizeMessageDetail]="invalidFileSizeMessage" invalidFileTypeMessageSummary="{0}:"
      [invalidFileTypeMessageDetail]="invalidFileTypeMessage" [files]="value">
      <ng-template pTemplate="file" let-file let-i="index">
        <div class="file-upload-flex-container">
          <ng-container [ngSwitch]="fileType(file)">
            <div class="file-upload-preview" *ngSwitchCase="'image'">
              <img *ngIf="file.objectURL" [src]="file.objectURL" width="50" />
              <span *ngIf="!file.objectURL" class="file-icon fa fa-file-image-o"></span>
            </div>
            <div class="file-upload-preview" *ngSwitchCase="'pdf'">
              <span class="file-icon pdf-icon fa fa-file-pdf-o"></span>
            </div>
            <div class="file-upload-preview" *ngSwitchDefault>
              <span class="file-icon fa fa-file"></span>
            </div>
          </ng-container>
          <div class="file-upload-name">
            {{ file.name }}
          </div>
          <div class="file-upload-size" *ngIf="!loading || file.size">
            {{ fileUploadComponent.formatSize(file.size) }}
          </div>
          <div class="file-upload-remove-btn" *ngIf="!showRemoveButton || showRemoveButton(file)">
            <span class="file-upload-action-icon" (click)="fileUploadComponent.remove($event, i)">
              <span class="glyphicon glyphicon-trash" pTooltip="Remover" tooltipPosition="bottom"></span>
            </span>
          </div>
          <div class="file-upload-download-btn" *ngIf="showDownloadButton && showDownloadButton(file)">
            <span class="file-upload-action-icon" (click)="downloadFile(file)">
              <span class="glyphicon glyphicon-download-alt" pTooltip="Download" tooltipPosition="bottom"></span>
            </span>
          </div>
        </div>
      </ng-template>
    </p-fileUpload>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.FileUploadComponent.html